export const CIRCLED_NUMBER_MARKS = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'] as const;

export const getCircleNumber = (index: number): string => CIRCLED_NUMBER_MARKS[index] ?? `${index + 1}`;
